import { ToolBarRate } from "modules/admin";
import SetLang, { canSwitchAppLang } from "components/setLang";
import ThemeButton from "./ThemeButton";
import UserDropDown from "./UserDropDown"
import conf from "conf/conf.js";

const ToolBarRightContainer = ({ UserNameItem = null }) => {
    return (
        <div>
            <ul className="list-unstyled">
                {!conf.currencyOnce && (
                    <li><ToolBarRate UserNameItem={UserNameItem} /></li>
                )}
                {canSwitchAppLang() && (
                    <li><SetLang /></li>
                )}
                <li><ThemeButton/></li>                 
                <li><UserDropDown/></li> 
            </ul>
        </div>
    )
}

export default ToolBarRightContainer;
